
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuolasecondaria",
      function () {
        return require("private-next-pages/scuolasecondaria/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuolasecondaria"])
      });
    }
  